import React from 'react';
import './Pracujemy.styles.scss';
import dotsImage from '../../assets/images/dots.svg';
import contactImage from '../../assets/images/contact.svg';
import calendarImage from '../../assets/images/calendar.svg';
import workImage from '../../assets/images/work.svg';
import payImage from '../../assets/images/pay.svg';

const Pracujemy = () => {
    return (
        <div className='container'>
            <div className='pracujemy-wrapper'>
                <div className="jakPracuemyTitle">
                    <div className="jakPracuemyTitleShadow">Как мы работаем</div>
                    <div className="jakPracuemyTitleText">Как мы работаем</div>
                </div>

                <div className='pracujemy-container'>
                    <div className='pracujemy-item'>
                        <div className='pracujemy-item-img-wrapp'>
                            <img src={contactImage} alt="contact" />
                        </div>
                        <div className='pracujemy-item-description'>
                            Свяжитесь с нами
                        </div>
                    </div>

                    <div className='dots-wrapp'>
                        <img className='dots' src={dotsImage} alt="dots" />
                    </div>

                    <div className='pracujemy-item'>
                        <div className='pracujemy-item-img-wrapp'>
                            <img src={calendarImage} alt="calendar" />
                        </div>
                        <div className='pracujemy-item-description'>
                            Закажите услугу онлайн
                        </div>
                    </div>

                    <div className='dots-wrapp'>
                        <img className='dots' src={dotsImage} alt="dots" />
                    </div>

                    <div className='pracujemy-item'>
                        <div className='pracujemy-item-img-wrapp'>
                            <img src={workImage} alt="work" />
                        </div>

                        <div className='pracujemy-item-description'>
                            Мы приедем и выполним работу
                        </div>
                    </div>

                    <div className='dots-wrapp'>
                        <img className='dots' src={dotsImage} alt="dots" />
                    </div>

                    <div className='pracujemy-item'>
                        <div className='pracujemy-item-img-wrapp'>
                            <img src={payImage} alt="pay" />
                        </div>
                        <div className='pracujemy-item-description'>
                            Оплата после выполнения услуги
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pracujemy;